<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
              <el-form-item label="抢单单号:" prop="demandNo">
                <el-input placeholder="" v-model="searchFrom.demandNo"></el-input>
              </el-form-item>
              <el-form-item label="抢单状态:" prop="status">
                <el-select v-model="searchFrom.status" placeholder="请选择">
                  <el-option v-for="val in options" :label="val.name" :value="val.id" :key="val.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn"  v-if="btnFlg[0]">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="addClick(scope.row)" v-if="scope.row.status == '1002' &&  btnFlg[1]">作废</el-button>
              <el-button type="text" size="mini" @click="resultFn(scope.row)" v-if="scope.row.status == '1203' &&  btnFlg[2]">结果</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="抢单单号" width="240">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="detailFn(scope.row)">{{scope.row.demandNo}}</span>
          </template>
        </el-table-column>
        <el-table-column  prop="status"  min-width="120" :formatter="statusFormat" label="抢单状态"></el-table-column>
        <el-table-column prop="demandFinalDate"  min-width="170" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="抢单截止时间"></el-table-column>
        <el-table-column prop="productTypeName"  min-width="220" :formatter="emptyFn" label="货物类型" show-overflow-tooltip></el-table-column>
         <el-table-column label="委托量" width="160">
          <template slot-scope="scope">
            <div>
              {{scope.row.productWeight}} 吨 / {{scope.row.productNum}} 件
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="unitPrice"  min-width="170" :formatter="emptyFn" label="抢单价"></el-table-column> -->
        <el-table-column label="抢单价" min-width="170">
          <template slot-scope="scope">
            <div>
              <span style="color: #0c46a2;cursor: pointer;"  v-if="scope.row.pricingMethod==1" @click="QGFn(scope.row)">{{scope.row.unitPrice}} 元/吨</span>
              <span style="color: #0c46a2;cursor: pointer;"  v-if="scope.row.pricingMethod==2" @click="QGFn(scope.row)">{{scope.row.unitPrice}} 元</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="carriageName"  min-width="170" :formatter="emptyFn" label="承运方"></el-table-column>
        <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#0c46a2">(发){{scope.row.deliverCompany}}</span>
              <span>{{scope.row.deliverPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.deliverPhone}}</span>
              <span style="margin-left:10px">{{scope.row.deliverAddress}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span style="color:#F56C6C">(收){{scope.row.receivingCompany}}</span>
              <span>{{scope.row.receivingPerson}}</span>
            </div>
            <div class="box1">
              <span>{{scope.row.receivingPhone}}</span>
              <span style="margin-left:10px">{{scope.row.receivingAddress}}</span>
            </div>
          </template>
        </el-table-column>
          <!-- <el-table-column label="发货信息" width="450">
          <template slot-scope="scope">
             <div class="box1">
              <span>{{scope.row.deliverProvinceName}}-{{scope.row.deliverCityName}}-{{scope.row.deliverAreaName}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收货信息" width="450">
          <template slot-scope="scope">
            <div class="box1">
              <span>{{scope.row.receivingProvinceName}}-{{scope.row.receivingCityName}}-{{scope.row.receivingAreaName}}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="hopeReceivingDate"  min-width="170" :formatter="(row, column,cellValue,index) => dateTimeFormat(row, column,cellValue,index, 1)" label="最晚提货时间"></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"  min-width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
                <el-form-item label="作废原因:" prop="reason" style="margin-top:10px;">
                 <el-input type="textarea" v-model="SQFrom.reason"></el-input>
                </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()" v-show="addBtnShow">确定</el-button>
        <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button>
      </span>
    </el-dialog>
    <el-dialog  title="查看结果"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="isEdit" @close="closeDialog" width="1100px" center>
        <div>
           <div class="spry">
              <div style="margin: 20px 0;display: flex;justify-content: space-between">
               <div>
                  成交承运商：{{result.carriageName}}
               </div>
               <div>
                  成交时间：{{dateFormatUtil('yyyy-MM-dd hh:ii', result.completeTime)}}
               </div>
              </div>
              <div class="tbox">
                <el-table :data="sDemandOfferList" border ref="CDtable" highlight-current-row  max-height="350px" >
                  <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
                  <el-table-column property="pricingMethod" label="报价方式"  min-width="150px">
                    <template scope="scope">{{[ "单价", "包干" ][scope.row.pricingMethod-1]}}</template>
                  </el-table-column>
                  <el-table-column prop="offerPrice" min-width="130px" :formatter="emptyFn" label="成交报价" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.pricingMethod == 1">{{scope.row.offerPrice}} 元/吨</span>
                        <span v-if="scope.row.pricingMethod == 2">{{scope.row.offerPrice}} 元</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dealPrice"  min-width="130px" :formatter="emptyFn" label="运费(元)"></el-table-column>
                  <el-table-column prop="serviceFee"  min-width="130px" :formatter="emptyFn" label="找车服务费(含税/元)"></el-table-column>
                  <el-table-column prop="incidental"  min-width="130px" :formatter="emptyFn" label="杂费(元)"></el-table-column>
                  <el-table-column  min-width="130px" :formatter="emptyFn" label="合计(元)">
                    <template scope="scope">
                      <div>
                        {{Number(toFixed(parseFloat(scope.row.dealPrice) + parseFloat(scope.row.serviceFee) + (scope.row.incidental ? parseFloat(scope.row.incidental) : 0), 2))}}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isEdit = false" type='primary'>关闭</el-button>
        </span>
    </el-dialog>
    <el-dialog  title="改价记录"  :close-on-click-modal="false" :close-on-press-escape="false"  :visible.sync="GJEdit" @close="closeDialog" width="700px" center>
        <div>
           <div class="spry">
              <div class="tbox">
                <el-table :data="OfferList" border ref="CDtable" highlight-current-row  max-height="350px" >
                  <el-table-column type="index" prop="date" width="55" :reserve-selection="true" label="序号"></el-table-column>
                  <el-table-column prop="price" min-width="160px" :formatter="emptyFn" label="抢单价格">
                    <!-- <template scope="scope">
                      <div>
                        {{scope.row.price}} 元
                      </div>
                    </template> -->
                    <template scope="scope">
                      <div  v-if="result1.pricingMethod==1">
                        {{scope.row.price}} 元/吨
                      </div>
                      <div v-else>
                        {{scope.row.price}} 元
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="addPriceTime"  min-width="170px" :formatter="dateTimeFormat" label="调价时间"></el-table-column>
                </el-table>
              </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="GJEdit = false" type='primary'>关闭</el-button>
        </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat, toFixed, dateFormatUtil } from '@/utils/util'
import { seckillDemandList, showBiddingResult, changePriceRecord, cancelDemand } from '@/api/soc-stock'
export default {
  data () {
    return {
      dateFormatUtil: dateFormatUtil,
      toFixed: toFixed,
      OfferList: [],
      GJEdit: false,
      result: {},
      isEdit: false,
      sDemandOfferList: [],
      options: [
        { name: '待抢单', id: 1002 },
        { name: '抢单成功', id: 1203 },
        { name: '抢单失败', id: 1202 },
        { name: '已作废', id: 1201 }
      ],
      title: '',
      addBtnShow: false,
      editBtnShow: false,
      SQFrom: {
      },
      SQMark: false,
      rules: {
        reason: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      result1: {},
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['00H0050100', '00H0050200', '00H0050300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/myOrder')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 状态格式化
    statusFormat (row, column, cellValue) {
      switch (cellValue) {
        case 1002:
          return '待抢单'
        case 1102:
          return '待比价'
        case 1203:
          return '抢单成功'
        case 1202:
          return '抢单失败'
        case 1201:
          return '已作废'
      }
    },
    QGFn (row) {
      this.GJEdit = true
      changePriceRecord({ demandId: row.id }).then(res => {
        console.log(res)
        this.OfferList = res.records
        this.$set(this.result1, 'pricingMethod', res.pricingMethod)
        // this.sDemandOfferList = [res]
        // console.log(this.sDemandOfferList)
        // console.log(this.sDemandOfferList[0].carriageName)
        // this.$set(this.result, 'carriageName', this.sDemandOfferList[0].carriageName)
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    detailFn (row) {
      this.$router.push({ name: 'details', query: { id: row.id } })
    },
    resultFn (row) {
      showBiddingResult({ demandId: row.id, offerFlag: 0 }).then(res => {
        this.isEdit = true
        console.log(res)
        this.sDemandOfferList = [res]
        console.log(this.sDemandOfferList)
        console.log(this.sDemandOfferList[0].carriageName)
        this.$set(this.result, 'carriageName', this.sDemandOfferList[0].carriageName)
        this.$set(this.result, 'completeTime', this.sDemandOfferList[0].completeTime)
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    // 添加
    addClick (row) {
      this.title = '作废'
      this.addBtnShow = true
      this.editBtnShow = false
      this.SQMark = true
      this.SQFrom.id = row.id
    },
    SQsave () {
      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cancelDemand(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '作废成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      seckillDemandList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    closeDialog () {
      // this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
